import React, { Fragment } from 'react';
import { TableCell, TableRow, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ILead } from 'src/interfaces/lead';
import { IUser } from 'src/interfaces/user';

import { CapitalizeNames } from 'src/utils/capitalize';

import {
    AUTOMATED_FROM_FIELDS,
    AUTOMATED_STRING,
    MANUAL_FROM_FIELDS,
    MANUAL_STRING,
} from 'src/constants/lead';
import { authorize } from 'src/utils/auth';
import {
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
} from 'src/components/access';

interface ILeadFromRow {
    lead: ILead;
    user: IUser;
}

export const LeadFromRow = ({ lead, user }: ILeadFromRow) => {
    const { t } = useTranslation();

    /**
     * Handles conversion of lead source name to displayable string.
     * @param leadFrom - Lead source name to be handled.
     * @returns Displayable string representing the lead source.
     */
    const handleFromName = (leadFrom: string): string => {
        let from = '- - -';
        if (AUTOMATED_FROM_FIELDS.includes(leadFrom))
            from = `${t(`Leads.${AUTOMATED_STRING}`)} (${CapitalizeNames(
                leadFrom
            )})`;
        else if (MANUAL_FROM_FIELDS.includes(leadFrom))
            from = t(`Leads.${MANUAL_STRING}`);
        return from;
    };

    return (
        <Fragment>
            {lead &&
                lead.from &&
                authorize(
                    user?.accessLevel,
                    DEVELOPER_LEVEL_ACCESS,
                    GROUP_LEVEL_ACCESS
                ) && (
                    <TableRow>
                        <TableCell style={{ fontWeight: 500 }}>
                            {t('Leads.From')}
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2" color="textSecondary">
                                {lead && lead.from
                                    ? handleFromName(lead.from)
                                    : '- - -'}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )}
        </Fragment>
    );
};
